(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vs-footer"]) return;
  try {
    
  function footerMenus() {
    var tabHeadings = document.querySelectorAll('[data-footer-heading]');
    tabHeadings.forEach((item, index) => {
      var key = item.getAttribute('data-tab-heading');
      var tab = document.querySelector('[data-tab="' + key + '"]');

      if (window.innerWidth < 990) {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          tab.classList.toggle('hidden');
        });
        tab.classList.add('hidden');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', footerMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.currentState = 'reset';
      this.pendingState = null;
      this.isTicking = false;
      this.scrollDeltaThreshold = 4;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.flushPendingState = this.flushPendingState.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = Math.abs(scrollTop - this.currentScrollTop);

      if (scrollDelta < this.scrollDeltaThreshold) return;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      let nextState = this.currentState;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        nextState = 'hidden';
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          nextState = 'revealed';
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          nextState = 'hidden';
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        nextState = 'reset';
      }

      this.queueState(nextState);

      this.currentScrollTop = scrollTop;
    }

    queueState(nextState) {
      if (nextState === this.currentState) return;

      this.pendingState = nextState;
      if (this.isTicking) return;

      this.isTicking = true;
      requestAnimationFrame(this.flushPendingState);
    }

    flushPendingState() {
      this.isTicking = false;

      if (!this.pendingState || this.pendingState === this.currentState) return;

      if (this.pendingState === 'hidden') {
        this.hide();
      } else if (this.pendingState === 'revealed') {
        this.reveal();
      } else {
        this.reset();
      }

      this.pendingState = null;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.currentState === 'hidden') return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.currentState = 'hidden';
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.currentState === 'revealed') return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.currentState = 'revealed';
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.currentState === 'reset') return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.currentState = 'reset';
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
